// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { createRef, useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import SupportIcon from '../../assets/images/problem.svg';
import SupportActiveIcon from '../../assets/images/problem-active.svg';

import QuestionIcon from '../../assets/images/question-white.svg';
import QuestionActiveIcon from '../../assets/images/question-white-active.svg';
import Row from '../../components/Row';
import Column from '../../components/Column';
import { updateFooterVisibleHeight } from '../../redux/actionCreators/mainLayoutActions';
import { FormattedMessage, useIntl } from 'react-intl';
import MemberContext from '../../contexts/MemberContext';

const otherS = {
  Container: styled.footer`
    height: 50px;
    display: flex;
    align-items: center;
    padding: 0 24px;
    background-color: #313131;
    position: relative;
  `,
  Left: styled.div`
    width: 0;
    flex: 0 0 0;
    justify-content: flex-start;

    > * {
      flex-shrink: 0;
    }
  `,
  Copyright: styled.p`
    margin: 0 auto;
    font-size: 12px;
    line-height: 17px;
    color: #848484;
  `,
  Right: styled(Row).attrs({ alignY: 'center' })`
    width: 0;
    flex: 0 0 0;
    justify-content: flex-end;

    > * {
      flex-shrink: 0;
    }

    > * + * {
      margin-left: 24px;
    }
  `,
  ButtonIcon: styled.div`
    width: 32px;
    height: 32px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  `,
  ButtonText: styled.span`
    font-size: 16px;
    line-height: 23px;
    color: #FFFFFF;
  `,
  ContactMessage: styled.p`
    font-size: 14px;
    line-height: 20px;
    color: #C9C9C9;
  `,
  Email: styled.a`
    color: inherit;
    text-decoration: underline;
  `,
}

const S = {
  ...otherS,
  Button: styled.button<{ image: string; activeimage: string }>`
    height: 32px;
    display: flex;
    align-items: center;
    cursor: pointer;

    > * + * {
      margin-left: 8px;
    }

    ${otherS.ButtonIcon} {
      background-image: url(${props => props.image });
    }

    &:hover, &:active {
      ${otherS.ButtonIcon} {
        background-image: url(${props => props.activeimage });
      }
    }
  `,
}

const Footer: React.FC = (props) => {
  const ref = createRef<HTMLElement>();
  const dispatch = useDispatch();
  const intl = useIntl();
  const member = useContext(MemberContext);

  function update() {
    if (!ref.current) {
      return;
    }
    const y = window.innerHeight - ref.current.getBoundingClientRect().top
    const height = y < 0 ? 0 : y;
    dispatch(updateFooterVisibleHeight(height));
  }

  useEffect(() => {
    update();
    window.addEventListener('resize', update);
    window.addEventListener('scroll', update);

    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('scroll', update);
    }
  }, [ref])

  const data = {
    id: 1,
    title: '',
    category: '',
    message: ''
  };

  function renderActions() {
    if (member.isLogin) {
      return (
        <>
          <S.Button
            as={Link}
            to="/faq"
            image={QuestionIcon}
            activeimage={QuestionActiveIcon}
          >
            <S.ButtonIcon/>
            <S.ButtonText><FormattedMessage id="A009" /></S.ButtonText>
          </S.Button>
          <S.Button
            as={Link}
            to="/support"
            image={SupportIcon}
            activeimage={SupportActiveIcon}
          >
            <S.ButtonIcon/>
            <S.ButtonText><FormattedMessage id="A010" /></S.ButtonText>
          </S.Button>
        </>
      )
    }

    return (
      <S.ContactMessage>
        <FormattedMessage id="A006" />
        <S.Email href="mailto:training@ecloudvalley.com">training@ecloudvalley.com</S.Email>
      </S.ContactMessage>
    )
  }

  return (
    <S.Container
      ref={ref}
      {...props}
    >
      <S.Left></S.Left>
      <S.Copyright>
        {intl.formatMessage({ id: 'A005' }, { year: new Date().getFullYear() })}
      </S.Copyright>
      {/* <Row gap={90}>
        <TinyText as={Link} to="/privacy" color="White4">
          隱私條款
        </TinyText>
        <TinyText as={Link} to="/term" color="White4">
          使用者條款
        </TinyText>
        <TinyText as={Link} to="/services" color="White4">
          客服中心
        </TinyText>
      </Row> */}
      <Column>
      </Column>
      <S.Right>
        {renderActions()}
      </S.Right>
    </S.Container>
  );
}

export { Footer as default };
